<template>
  <p class="content-preview-box">
    <v-clamp class="content-clamp" :max-lines="2" ellipsis="...">
      {{ renderSynopsis(synopsis) }}
      <template #after>
        <a
          href="javascript:void(0)"
          class="more"
          @click.prevent="$emit('on-click-more')"
        >
          더보기</a
        >
      </template>
    </v-clamp>
  </p>
</template>
<script setup>
  import { defineProps, defineEmits, onMounted } from 'vue'
  import { getDecodedHTMLText } from '@/common/utils/player.util'
  import VClamp from 'vue-clamp'

  const props = defineProps({
    synopsis: {
      type: String,
      default: '',
    },
  })

  defineEmits(['on-click-more'])

  const renderSynopsis = (synopsis) => {
    return getDecodedHTMLText(synopsis)
  }

  const addClassOnVClamp = () => {
    const synopsisDOM = document.querySelector('.content-clamp > span > span')

    if (props.synopsis && synopsisDOM) {
      synopsisDOM?.classList.add('text')
    }
  }

  onMounted(() => {
    addClassOnVClamp()
  })
</script>
